<template>
  <router-view />
</template>

<script>
export default {
  name: 'EquipmentStorageIndex'
}
</script>
